import { Injectable  } from '@angular/core';

@Injectable ()
export class TripService {
  trip: number;

  setTrip(value) {
    this.trip = value;
  }
  getTrip() {
    return this.trip;
  }

}
